/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createChangeFromDiscriminatorValue, createProblemDetailsFromDiscriminatorValue, type Change, type ProblemDetails } from '../models/index.js';
// @ts-ignore
import { AcknowledgeRequestBuilderRequestsMetadata, type AcknowledgeRequestBuilder } from './acknowledge/index.js';
// @ts-ignore
import { ChartersRequestBuilderRequestsMetadata, type ChartersRequestBuilder } from './charters/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Changes
 */
export interface ChangesRequestBuilder extends BaseRequestBuilder<ChangesRequestBuilder> {
    /**
     * The Acknowledge property
     */
    get acknowledge(): AcknowledgeRequestBuilder;
    /**
     * The Charters property
     */
    get charters(): ChartersRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Change[]>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 401 status code
     * @throws {ProblemDetails} error when the service returns a 403 status code
     */
     get(requestConfiguration?: RequestConfiguration<ChangesRequestBuilderGetQueryParameters> | undefined) : Promise<Change[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ChangesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface ChangesRequestBuilderGetQueryParameters {
    isActive?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const ChangesRequestBuilderUriTemplate = "{+baseurl}/Changes?isActive={isActive}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ChangesRequestBuilderNavigationMetadata: Record<Exclude<keyof ChangesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    acknowledge: {
        requestsMetadata: AcknowledgeRequestBuilderRequestsMetadata,
    },
    charters: {
        requestsMetadata: ChartersRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ChangesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ChangesRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createChangeFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
